import React from "react"
import { useShipmentsForm } from "../../hooks/useShipmentsForm"
import { translate } from "../../translations/translations"
import Button from "../Shared/Button"
import Input from "../Shared/Input"
import Tooltip from "../Shared/Tooltip"
import { useCalculator } from "src/context/CalculatorContext"
import { AssetTypes } from "src/models/AssetType"
import styles from "./InputForm.module.css"

interface Props {
  onNext: () => void
  onBack: () => void
}

const ShipmentsInput: React.FC<Props> = ({ onNext, onBack }) => {
  const {
    shipments,
    formErrors,
    numberOfTrackedAssets,
    handleInputChange,
    validateInputs,
  } = useShipmentsForm()

  const { shipments: calculatorShipments } = useCalculator()
  const assetType = calculatorShipments.assetType
  const assetTypeLabel = AssetTypes.find(
    (type) => type.key === assetType
  )?.labelKey

  const handleSubmit = () => {
    if (validateInputs()) {
      onNext()
    }
  }

  return (
    <div className={styles.inputFormContainer}>
      <div className={styles.formInnerContainer}>
        <h2 className={styles.formTitle}>
          {assetTypeLabel ? translate(assetTypeLabel) : translate("unknown")}
        </h2>
        <div className={styles.formGroup}>
          <label htmlFor="yearlyVolume" className={styles.formLabel}>
            {translate("total_yearly_volume")}
            <Tooltip text={translate("total_yearly_volume", "en", assetType)} />
          </label>
          <div className={styles.inputWrapper}>
            <Input
              id="yearlyVolume"
              type="number"
              min="0"
              unit="pcs"
              value={shipments.yearlyVolume ?? ""}
              onChange={(e) =>
                handleInputChange("yearlyVolume", e.target.value)
              }
              onBlur={() => validateInputs()}
            />
            {formErrors.yearlyVolume && (
              <span className={styles.errorMessage}>
                {formErrors.yearlyVolume}
              </span>
            )}
          </div>
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="percentageToTrack" className={styles.formLabel}>
            {translate("percentage_to_track")}
            <Tooltip text={translate("percentage_to_track", "en", assetType)} />
          </label>
          <div className={styles.inputWrapper}>
            <Input
              id="percentageToTrack"
              type="number"
              min="0"
              max="100"
              unit="%"
              value={shipments.percentageToTrack || ""}
              onChange={(e) =>
                handleInputChange("percentageToTrack", e.target.value)
              }
              onBlur={() => validateInputs()}
            />
            {formErrors.percentageToTrack && (
              <span className={styles.errorMessage}>
                {formErrors.percentageToTrack}
              </span>
            )}
          </div>
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="numberOfTrackedAssets" className={styles.formLabel}>
            {translate("number_of_tracked_assets")}
            <Tooltip
              text={translate("number_of_tracked_assets", "en", assetType)}
            />
          </label>
          <div className={styles.inputWrapper}>
            <Input
              id="numberOfTrackedAssets"
              type="number"
              unit="pcs"
              value={numberOfTrackedAssets || ""}
              readOnly
            />
          </div>
        </div>
        <div className={styles.formGroup}>
          <div className={styles.buttonContainer}>
            <Button onClick={onBack} label={translate("back")} />
            <Button onClick={handleSubmit} label={translate("next")} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShipmentsInput
